/* eslint-disable no-unused-vars */
import { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { ApiAssetType, ApiPaymentType } from '@agunity/api-v4';
import { Grid } from '@mui/material';

import AgDropdown from '../../../stories/AgDropdown';
import AgButton from '../../../stories/Components/AgButton';
import { useToast } from '../../../redux/hooks/toast';

type DropdownOption =  {
  id: string | number;
  name: string;
};

export type FormData = {
  assetType: number;
  currency: number;
  paymentType: number;
};

const AddForm = ({ assetTypes = [], currencies = [], onCancel, onSubmit }: { assetTypes: ApiAssetType[]; currencies: ApiAssetType[]; onCancel: () => void; onSubmit: (formData: FormData) => void }) => {
  const messages = useIntl().formatMessage;
  const { toast } = useToast();

  const paymentTypeOptions: DropdownOption[] = useMemo(() => {
    return [
      { id: ApiPaymentType.ReceiptCash, name: messages({ id: 'PAYMENT_TYPE_0' }) },
      { id: ApiPaymentType.ReceiptProduce, name: messages({ id: 'PAYMENT_TYPE_1' }) },
      { id: ApiPaymentType.PhysicalCash, name: messages({ id: 'PAYMENT_TYPE_2' }) },
      { id: ApiPaymentType.ReceiptBank, name: messages({ id: 'PAYMENT_TYPE_3' }) },
      { id: ApiPaymentType.NoPayment, name: messages({ id: 'PAYMENT_TYPE_4' }) },
    ];
  }, [messages]);

  const [formData, setFormData] = useState<FormData>();

  const handleChange = useCallback((event: string, field: string) => {
    let value: unknown = event;
    if (field === 'assetType') {
      value = assetTypes.find(({ name }) => name === event)?.id;
    }
    if (field === 'currency') {
      value = currencies.find(({ name }) => name === event)?.id;
    }
    if (field === 'paymentType') {
      value = paymentTypeOptions.find(({ name }) => name === event)?.id;
    }
    
    setFormData({ ...formData, [field]: value } as FormData);
  }, [assetTypes, currencies, formData, paymentTypeOptions]);

  const handleAdd = useCallback(() => {
    if (!formData?.assetType || !formData?.currency || !formData?.paymentType?.toString()) {
      toast('error', messages({ id: 'PAYMENT_TYPE_ERROR_MESSAGE' }), { temporary: true });
      return;
    }

    onSubmit(formData);
  }, [formData, messages, onSubmit, toast]);

  return (
    <Grid container direction='row' spacing={2} sx={{ overflowX: 'hidden' }}>
      <Grid item xs={12} md={4}>
        <AgDropdown
          id='itemType'
          inputLabel={messages({ id: 'ASSET_TYPE' })}
          placeholder={messages({ id: 'SELECT' })}
          value={(assetTypes || [])?.find(({ id }) => id === formData?.assetType)?.name || ''}
          options={assetTypes as DropdownOption[]}
          onChange={(event: string) => handleChange(event, 'assetType')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <AgDropdown
          id='itemType'
          inputLabel={messages({ id: 'PAYMENT_TYPE_CURRENCY' })}
          placeholder={messages({ id: 'SELECT' })}
          value={(currencies || [])?.find(({ id }) => id === formData?.currency)?.name || ''}
          options={currencies as DropdownOption[]}
          onChange={(event: string) => handleChange(event, 'currency')}
          onBlur={() => {}}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <AgDropdown
          id='itemType'
          inputLabel={messages({ id: 'PAYMENT_TYPE' })}
          placeholder={messages({ id: 'SELECT' })}
          value={(paymentTypeOptions || [])?.find(({ id }) => id === formData?.paymentType)?.name || ''}
          options={paymentTypeOptions}
          onChange={(event: string) => handleChange(event, 'paymentType')}
          onBlur={() => {}}
        />
      </Grid>

      <Grid 
        item 
        gap={2} 
        xs={12}
        mt={3}
        display='flex'
        justifyContent='flex-end'
      >
        <AgButton
          variant='outlined'
          label={messages({ id: 'CANCEL' })}
          onClick={onCancel}
        />
        <AgButton
          label={messages({ id: 'ADD' })}
          onClick={handleAdd}
        />
      </Grid>
    </Grid>
  );
};

export default AddForm;